module.exports = __webpack_public_path__ + "static/media/project-thumbnail18.20cb46cf.jpg";